import { FormattedMessage } from 'react-intl';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { NewScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Option } from '@sorare/core/src/components/search/Option';
import { formatScarcity } from '@sorare/core/src/lib/cards';
import { glossary } from '@sorare/core/src/lib/glossary';
import {
  PlayerSearchViewAttributes,
  StatsRarity,
} from '@sorare/core/src/lib/playerSearchView';

import { SeasonalityToggle } from '../SeasonalityToggle';
import { useManagePlayerSearchView } from '../useManagePlayerSearchView';

const rarities: StatsRarity[] = [
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

const raritiesOptions = rarities.map(rarity => ({
  label: formatScarcity(rarity),
  value: rarity,
}));

export const Prices = () => {
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();

  const rarity = statsManager[PlayerSearchViewAttributes.RARITY];

  return (
    <Vertical>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage {...glossary.lowestPrice} />
      </LabelM>
      <SeasonalityToggle />
      <Vertical gap={0}>
        {raritiesOptions.map(({ value, label }) => (
          <Option
            key={value}
            active={rarity === value}
            onClick={() =>
              updatePlayerSearchViewAttribute(
                PlayerSearchViewAttributes.RARITY,
                value
              )
            }
            variant="radio"
          >
            <NewScarcityIcon rarity={value} size={2} />
            <span>{label}</span>
          </Option>
        ))}
      </Vertical>
    </Vertical>
  );
};
